import { useMemo, useCallback } from "react";
import { Menu, Dropdown } from "antd";
import {useDispatch, useSelector} from "react-redux";
import { useHistory } from "react-router-dom";
import { ROUTES } from "utils/constants";
import { actionMenu } from "svgs";
import { IssuesState } from "types/store";
import { setModalName, setSelectedIssue } from "store/actions";
import {AppState} from "../../../store";

export default function DropdownAction({
  issue,
}: {
  issue: IssuesState["selectedIssue"];
}) {
    const { userType } = useSelector<AppState, AppState["common"]>(
        (state) => state.common
    );
  const dispatch = useDispatch();
  const history = useHistory();
  const onIssueSelected = () => {
    dispatch(setSelectedIssue(issue));
    history.push(`${ROUTES.issue_detail}/${issue?.id}`);
  };
  const onArchiveIssue = useCallback((e) => {
    e.domEvent.stopPropagation();
    dispatch(setSelectedIssue(issue));
    dispatch(setModalName("delete_issue"));
  }, [dispatch, issue]);

  const menu = useMemo(
    () => (
      <Menu>
        <Menu.Item key="1">
          <span onClick={onIssueSelected}>
            Issue Details
          </span>
        </Menu.Item>
          {(userType != 7 && userType != 3) && <Menu.Item key="2" className="delete-action" onClick={onArchiveIssue}>
          Archive
        </Menu.Item> }
      </Menu>
    ),
    [issue, onArchiveIssue]
  );

  return (
    <Dropdown overlay={menu} trigger={["click"]}>
      <a className="ant-dropdown-link" onClick={(e) => e.stopPropagation()}>{actionMenu}</a>
    </Dropdown>
  );
}
